import React, { useRef } from 'react';

const Textarea = ({
	className = '',
	onChange,
	value,
	style = { overflow: 'hidden', height: 'auto' },
	...props
}) => {
	const textareaRef = useRef();
	return (
		<textarea
			ref={textareaRef}
			type="text"
			className={`w-100 ${className}`}
			onChange={(e) => {
				textareaRef.current.style.height = 'auto';
				textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
				onChange(e);
			}}
			value={value}
			style={{
				...style
			}}
			onFocus={(e) => {
				const length = e.target.value.length;
				e.target.setSelectionRange(length, length);
				if (e.target.value.length > 0) {
					setTimeout(() => {
						textareaRef.current.style.height = 'auto';
						textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
					}, 0);
				}
			}}
			{...props}
		/>
	);
};

export default Textarea;
